export const LANGUAGES = [
	{ value: "en", text: "English" },
	{ value: "es", text: "Español" }
];
export const DEFAULT_LANGUAGE = "en";
